import SegmentInfoField from "./segmentInfoField";

export default class SegmentInfo {
  public idSegmentInfo: number = 0;
  public idProject: number = 0;
  public showRoadName: boolean = false;
  public showThematicField: boolean = false;
  public segmentInfoFields: SegmentInfoField[] = [];
}
